module.exports = __webpack_public_path__ + "media/assets/images/logo-movimenta-positivo-eaea3d2976604dc24abe5c06ba6b7eab.png";